<template>
  <database-management
    :headings="headings"
    :entries="entries"
    :loading="loading"
    :sort="sort"
    :sort-dir="sortDir"
    @showModal="(id) => {
      selectedEntryId = id
      showModal()
    }"
    @updateSort="(key) => {
      updateSort(key)
    }">
    <template v-slot:heading>Opportunity Management</template>
    <template v-slot:list>
      <opportunity-management-list-item
        v-for="opportunity in sortedEntries"
        :key="opportunity.id"
        :opportunity="opportunity"
        @edit="(id) => {
            selectedEntryId = id
            showModal()
          }"/>
    </template>
    <template v-slot:modal>
      <opportunity-management-modal
        ref="modal"
        :opportunity="selectedEntryIndex !== -1 ? entries[selectedEntryIndex] : defaultEntry"
        :categories="categories"
        :offer="is_offer_enabled"
        @create="(opportunity) => { add(opportunity) }"
        @update="(opportunity) => { update(opportunity) }"
      />
    </template>
  </database-management>
</template>

<script>
import { http } from 'utils'
import { cloneDeep } from 'lodash'
import OpportunityManagementListItem from './OpportunityManagementListItem'
import OpportunityManagementModal from './OpportunityManagementModal'
import DatabaseManagement from './templates/DatabaseManagement'
import { databaseManagement } from 'mixins'

export default {
  mixins: [databaseManagement],
  components: {DatabaseManagement, OpportunityManagementModal, OpportunityManagementListItem},
  data () {
    return {
      categories: [],
      defaultEntryData: {
        active: true,
        budget: null,
        category: null,
        category_id: null,
        field_set: 0,
        optional_fields: [],
        points: null,
        name: null,
        appearance_type: 'in_person'
      },
      is_offer_enabled: false,
      headings: [
        { key: 'id', label: 'Reference' },
        { key: 'name', label: 'Name' },
        { key: 'appearance_type', label: 'Appearance Type' },
        { key: 'field_set', label: 'Field Set' },
        { key: 'optional_fields', label: 'Optional Fields' },
        { key: 'value', label: 'Value' },
        { key: 'category_id', label: 'Category' },
        { key: 'active', label: 'Active' }
      ]
    }
  },

  computed: {
    sortedEntries () {
      const opportunities = cloneDeep(this.entries)
      return opportunities.sort((a, b) => {
        let aValue = a[this.sort]
        let bValue = b[this.sort]
        if (typeof aValue === 'string') {
          aValue = aValue.toLowerCase()
        }
        if (typeof bValue === 'string') {
          bValue = bValue.toLowerCase()
        }
        if (this.sort === 'value') {
          aValue = a['points'] ? a['points'] : a['budget']
          bValue = b['points'] ? b['points'] : b['budget']
        }
        if (this.sortDir === 'asc') {
          return aValue > bValue ? 1 : -1
        }
        return aValue < bValue ? 1 : -1
      })
    }
  },

  created () {
    http.get('opportunities/manage')
      .then((response) => {
        this.entries = response.data
        this.loading = false
      })
    http.get('categories')
      .then((response) => {
        this.categories = response.data
      })
    this.is_offer_enabled = this.$offersModuleEnabled
  }
}
</script>
